import React from "react";
import { Card, Switch, TextButton, IconCheckCircle, ICON_SIZE } from "cdk-radial";
import config from "../config/app.conf.json";
import { ADVANCE_PLAN_CHANGE } from "../Utils/constants";
import { ADD_A_PLAN } from "./screen";

const AdvancePlanCard = (props) => {
    const { plan, installFee, isInstallFeeEnabled, subPlan, setBundlePlanDetails, setSubPlan, setScreen } = props;
    const { isActive, title, baseValue, description, containers } = plan;

    const handlePlanToggle = (event, title) => {
        const { checked } = event.target;
        setBundlePlanDetails({
            field: ADVANCE_PLAN_CHANGE.PLAN_TOGGLE,
            value: {
                planName: title.toLowerCase(),
                isActive: checked
            },
        });
    };

    const handlePlanEdit = () => {
        props.clearSubPlanContainer();
        if (plan.containers && plan.containers.length > 0) {
            plan.containers.forEach(container => {
                const endpointsObj = (container.endpoints || []).reduce((acc, ep) => {
                    acc[ep.endpointId] = ep;
                    return acc;
                }, {});
                const channelsObj = (container.channels || []).reduce((acc, ch) => {
                    acc[ch.id] = ch;
                    return acc;
                }, {});
                props.setSubPlanContainer({
                    id: container.id,
                    name: container.name,
                    description: container.description,
                    quotaLimit: container.quotaLimit,
                    overages: container.overages,
                    apiEndpoints: endpointsObj,
                    channels: channelsObj,
                });
            });
        }
        setSubPlan(subPlan);
        setScreen(ADD_A_PLAN);
    };

    return (
      <>
        <Card className="overage-card">
          {subPlan === "custom" ? <></> : <Switch
            checked={isActive}
            label=""
            name={`switch-${title}`}
            onChange={(event) => handlePlanToggle(event, title)}
          />}
          <div className={`overage-card-title ${subPlan === "custom" ? "custom-card-title" : ""}`} title={title}>{title}</div>
          <div className="overage-card-price">
            <div className="overage-card-price-container">
              <span className="currency-prefix">$</span>
              <span className="base-price">{baseValue}</span>
              <span className="base-price-suffix">/ Month</span>
            </div>
            <div className="overage-card-install-fee">
                {isInstallFeeEnabled && installFee && (
                    <>+ ${installFee} Install Fee</>
                )}
            </div>
          </div>
          <div className="overage-card-description">{description}</div>
          <div className={`overage-card-container ${subPlan === "custom" ? "custom-card-container" : ""}`}>
            {containers.map((container, index) => (
              <div className="overage-card-container-box" key={index}>
                <div className="overage-card-container-box-checkIcon">
                  <IconCheckCircle size={ICON_SIZE.SMALL} />
                </div>
                <div className="overage-card-container-box-details">
                  <div className="overage-card-container-box-name">
                    {container.name}
                  </div>
                  <div className="overage-card-container-box-baseValue">
                    {container.quotaLimit} calls per month
                  </div>
                  <div className="overage-card-container-box-overage">
                    ${container.overages} overage fee
                  </div>
                </div>
              </div>
            ))}
          </div>
          <TextButton
            className="overage-card-edit-button"
            onClick={handlePlanEdit}
            text="Edit"
          />
        </Card>
      </>
    );
};

export default AdvancePlanCard;